window.max_quiz_assets = 250
window.max_quiz_error = "You've selected too many questions. Please limit to 250 or less."